import { useState, useEffect } from 'react';

interface UseScrollPositionOptions {
  threshold?: number;
  throttleMs?: number;
}

export const useScrollPosition = ({ 
  threshold = 80, 
  throttleMs = 16 
}: UseScrollPositionOptions = {}) => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    let timeoutId: NodeJS.Timeout;

    const handleScroll = () => {
      // Throttle scroll events for performance
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const scrollY = window.scrollY;
        setIsScrolled(scrollY > threshold);
      }, throttleMs);
    };

    // Set initial state
    setIsScrolled(window.scrollY > threshold);

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
      clearTimeout(timeoutId);
    };
  }, [threshold, throttleMs]);

  return isScrolled;
};